export interface HistoryState {
  present: any;
  past: any[];
  future: any[];
}

export class HistoryManager {
  private state: HistoryState;
  
  constructor(initialState: any) {
    this.state = {
      present: initialState,
      past: [],
      future: []
    };
  }
  
  push(state: any) {
    // Если есть будущее, очищаем его
    if (this.state.future.length > 0) {
      this.state = {
        ...this.state,
        future: []
      };
    }
    
    this.state = {
      present: state,
      past: [...this.state.past, this.state.present],
      future: []
    };
  }
  
  undo(): HistoryState | null {
    if (this.state.past.length === 0) return null;
    
    const previous = this.state.past[this.state.past.length - 1];
    const newPast = this.state.past.slice(0, this.state.past.length - 1);
    
    this.state = {
      present: previous,
      past: newPast,
      future: [this.state.present, ...this.state.future]
    };
    
    return this.state;
  }
  
  redo(): HistoryState | null {
    if (this.state.future.length === 0) return null;
    
    const next = this.state.future[0];
    const newFuture = this.state.future.slice(1);
    
    this.state = {
      present: next,
      past: [...this.state.past, this.state.present],
      future: newFuture
    };
    
    return this.state;
  }
  
  canUndo(): boolean {
    return this.state.past.length > 0;
  }
  
  canRedo(): boolean {
    return this.state.future.length > 0;
  }
}